import { TagIdToNameMap } from "../types/Tag";

export type InterestedPropertyType = {
  id: number;
  name: string;
};

// 「未選択（興味未設定ユーザー）」を表す sentinel。バックエンドは 0 を「興味未設定」として扱い、他IDとOR検索する。
export const INTEREST_UNSET_ID = 0;
export const INTEREST_UNSET_LABEL = "未選択";
export const INTEREST_UNSET_OPTION: InterestedPropertyType = { id: INTEREST_UNSET_ID, name: INTEREST_UNSET_LABEL };

const fallbackInterestedPropertyTypes: InterestedPropertyType[] = Object.entries(TagIdToNameMap)
  .map(([id, name]) => ({ id: Number(id), name }))
  .sort((a, b) => a.id - b.id);

export const getInterestedPropertyTypes = (
  masterInterestedPropertyTypes?: InterestedPropertyType[]
): InterestedPropertyType[] => {
  if (masterInterestedPropertyTypes && masterInterestedPropertyTypes.length > 0) {
    return masterInterestedPropertyTypes;
  }
  return fallbackInterestedPropertyTypes;
};

// 検索フィルタ用に先頭へ「未選択」を追加した選択肢を返す。
export const getInterestedPropertyTypesWithUnset = (
  masterInterestedPropertyTypes?: InterestedPropertyType[]
): InterestedPropertyType[] => {
  return [INTEREST_UNSET_OPTION, ...getInterestedPropertyTypes(masterInterestedPropertyTypes)];
};

export const getInterestedPropertyTypeNameMap = (
  masterInterestedPropertyTypes?: InterestedPropertyType[]
): Record<number, string> => {
  return Object.fromEntries(
    getInterestedPropertyTypes(masterInterestedPropertyTypes).map((t) => [t.id, t.name])
  );
};

// 検索フィルタ履歴タイトル用。「未選択」(id=0) を含むIDから名称への変換マップを返す。
export const getInterestedPropertyTypeNameMapWithUnset = (
  masterInterestedPropertyTypes?: InterestedPropertyType[]
): Record<number, string> => {
  return Object.fromEntries(
    getInterestedPropertyTypesWithUnset(masterInterestedPropertyTypes).map((t) => [t.id, t.name])
  );
};

